<template>
  <div class="login">
    <div class="login__wrap">
      <h1 class="login__title">类中后台解决方案</h1>
      <a-form
        class="login__form"
        :form="form"
      >
        <a-form-item>
          <a-input
            placeholder="账号"
            v-decorator="[
            'username',
            { initialValue: username, rules: [{ required: true, message: '请输入账号' }] },
          ]"
          >
            <a-icon
              slot="prefix"
              type="user"
            />
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-input
            placeholder="密码"
            v-decorator="[
            'password',
            { initialValue: password, rules: [{ required: true, message: '请输入密码' }] },
          ]"
          >
            <a-icon
              slot="prefix"
              type="lock"
            />
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            block
            @click="handleLogin"
          >登录</a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import { signIn } from '@/services/common';

export default {
  name: 'Login',
  data() {
    return {
      form: this.$form.createForm(this),
      username: 'admin',
      password: 'admin',
    };
  },
  methods: {
    handleLogin() {
      this.form.validateFields((error, values) => {
        if (!error) {
          signIn({
            username: values.username,
            password: values.password,
          }).then((res) => {
            this.$store.dispatch('setAccessToken', { accessToken: res.token, expire: res.expire });
            let { redirect } = this.$route.query;
            redirect = redirect || '/';
            this.$router.replace(redirect);
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.login {
  .flex-center(column);
  height: 100%;
  background: url(../assets/login-bg.svg) no-repeat 50% 50%;
  &__wrap {
    padding: 30px 60px;
    background: rgba(255, 255, 255, 0.6);
    border-radius: @border-radius-base;
    box-shadow: @shadow-3-down;
    transition: background 0.3s;
    &:hover {
      background: white;
    }
  }
  &__form {
    max-width: 300px;
    width: 100%;
  }
  &__title {
    text-align: center;
    margin-bottom: @padding-lg;
  }
}
</style>
